module.exports = __webpack_public_path__ + "img/w33b.3f32dac4.jpg";